import React from 'react'
import { ApolloProvider } from '@apollo/client'
import { render } from 'react-dom'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import { THEME } from './core/constants'
import {
  createApolloClient,
  initSentry,
  mergeResolvers,
} from './core/services'

import { Page } from './common/components'

import { AccountRouter } from './account/components'
import { AuthProvider } from './account/components/providers'
import { AuthRoute } from './account/components/routes'
import accountResolvers from './account/graphql/resolvers'
import { getAccessToken, registerAuthInterceptor } from './account/services'
import { ScrapingRouter } from './scraping/components'

import { getEnvironmentVariable } from './core/helpers'

import './index.css'

if (getEnvironmentVariable('NODE_ENV') === 'production') initSentry()

registerAuthInterceptor()

const resolvers = mergeResolvers([accountResolvers])
const apolloClient = createApolloClient({ getAccessToken, resolvers })

const AppRouter = () => (
  <Page>
    <AuthRoute path="/scraping" component={ScrapingRouter} />
  </Page>
)

render(
  <ThemeProvider theme={THEME}>
    <ApolloProvider client={apolloClient}>
      <AuthProvider>
        <BrowserRouter>
          <Switch>
            <Route path="/account" component={AccountRouter} />
            <Redirect exact from="/" to="/scraping/sessions/history" />
            <AuthRoute component={AppRouter} />
          </Switch>
        </BrowserRouter>
      </AuthProvider>
    </ApolloProvider>
  </ThemeProvider>,

  document.getElementById('root'),
)
